import { ca } from '@cian/analytics';

export function trackSubmitComplaint(label: string) {
  ca('event', {
    action: 'complain_send_main_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}
